import React, { ReactNode, ReactElement, cloneElement, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useSubMenu } from '../SubMenuContext';
import { AnimatePresence, motion } from 'framer-motion';
import { makeID } from '../lib/utils';

interface ItemTextProps {
	children: ReactNode;
	className?: string;
	skipSidebar?: boolean;
}

const ItemText = ({ children, skipSidebar = false, className }: ItemTextProps) => {
	const isValidReactElement = React.isValidElement(children);

	const [menuRandomID, setMenuRandomID] = useState('');

	useEffect(() => {
		setMenuRandomID(makeID());
	}, []);

	const { isSidebarOpen } = useSubMenu();

	const childWithClass = isValidReactElement ? (
		cloneElement(children as ReactElement<ItemTextProps>, {
			className: twMerge(`${(children as ReactElement<ItemTextProps>).props.className || ''}`),
		})
	) : (
		<>{children}</>
	);

	return (
		<AnimatePresence mode='popLayout'>
			{/* {shouldRender && ( */}
			<motion.div className={twMerge('w-full text-left', className)} key={menuRandomID} initial={skipSidebar ? { opacity: 1 } : { opacity: isSidebarOpen ? 1 : 0 }} animate={{ opacity: skipSidebar ? 1 : isSidebarOpen ? 1 : 0 }} transition={{ duration: .1 }} exit={{ opacity: 1 }}>
				{childWithClass}
			</motion.div>
			{/* )} */}
		</AnimatePresence>
	);
};

export default ItemText;
